import React from "react";
import IMAGES from "../../../../constant/images";

export default function Index() {
  return (
    <div className="flex flex-col items-center justify-center w-full h-full p-6 bg-[#ffffff]">
      {/* Image */}
      <div className="mb-6 flex items-center justify-center">
        <img
          src={IMAGES.notification_bell}
          alt="Empty Analytics"
          className="w-50 opacity-80"
        />
      </div>
      {/* Text */}
      <p className="text-center text-[#171717] text-base font-normal font-poppins">
        No Notification to show
      </p>
      <p className="text-center text-[#171717] text-sm font-normal font-poppins">
        You currently have no notifications. We will notify you when something
        new happens!
      </p>
    </div>
  );
}
